import React, { Component } from 'react';

import { MinicartContainer, MinicartButton } from './components';

class Minicart extends Component {
    state = {
        cartActiveClass: ''
    };

    closeMinicart = () => {
        this.setState({ cartActiveClass: '' });
    };

    handleCloseClick = () => {
        this.closeMinicart();
    };

    handleMinicartClick = () => {
        const { cartActiveClass } = this.state;
        cartActiveClass === ''
            ? this.setState({ cartActiveClass: 'uiPopup--active' })
            : this.closeMinicart();
    };

    render() {
        const { handleMinicartClick, handleCloseClick, closeMinicart } = this;
        const { animateMinicart } = this.props;
        const { cartActiveClass } = this.state;

        return (
            <div className={`uiPopup ${cartActiveClass}`}>
                <MinicartButton
                    handleMinicartClick={handleMinicartClick}
                    animateMinicart={animateMinicart}
                />
                <MinicartContainer
                    handleCloseClick={handleCloseClick}
                    closeMinicart={closeMinicart}
                />
            </div>
        );
    }
}

export default Minicart;



// WEBPACK FOOTER //
// ./src/components/Minicart/Minicart.jsx